export const SANDBOX_BANNER_HEIGHT = 30;
export const NAVBAR_HEIGHT = 58;
export const SIDEBAR_WIDTH = 220;
